import { render, staticRenderFns } from "./TagCloud.vue?vue&type=template&id=438fbde0&scoped=true"
import script from "./TagCloud.vue?vue&type=script&lang=ts"
export * from "./TagCloud.vue?vue&type=script&lang=ts"
import style0 from "./TagCloud.vue?vue&type=style&index=0&id=438fbde0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438fbde0",
  null
  
)

export default component.exports